exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._4f04ac{background:linear-gradient(#E9F3FA, #D8EAF6)}.dark-theme ._4f04ac{background:linear-gradient(#23282C, #272D32)}._340b88{background:linear-gradient(15deg, #066195, #0881c7)}.dark-theme ._340b88{background:linear-gradient(15deg, #066195, #0881c7)}", ""]);
// Exports
exports.locals = {
	"subtle": "_4f04ac",
	"primary": "_340b88"
};